<template>
  <Icon name="close" :color="NEUTRAL_SUPERDARK" :size="13" />
</template>

<script>
import { getColor } from '@/lego/utils/tailwind/config';
import Icon from '@/lego/components/icons/Icon.vue';

const NEUTRAL_SUPERDARK = getColor('neutral.superdark');

export default {
  components: { Icon },
  setup() {
    return {
      NEUTRAL_SUPERDARK,
    };
  },
};
</script>

<style lang="postcss" scoped>
.icon {
  @apply opacity-100 p-0 ml-micro my-auto;
}
</style>